import { useState } from 'react';
import { ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Button, Field, Input } from '../components/ui';

export function Login() {
  const { login, register, needsSetup } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      if (needsSetup) await register(email, password, fullName);
      else await login(email, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded bg-accent-600 text-sm font-bold text-white">
            O
          </span>
          <span className="text-lg font-semibold tracking-tight text-ink-900">Outreach</span>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-sm ring-1 ring-ink-200/70">
          <h1 className="text-base font-semibold text-ink-900">
            {needsSetup ? 'Create your account' : 'Sign in'}
          </h1>
          <p className="mt-1 text-sm text-ink-500">
            {needsSetup
              ? 'This is the first account, so it becomes the admin.'
              : 'Use the credentials for your Outreach workspace.'}
          </p>

          <form onSubmit={submit} className="mt-5 space-y-3">
            {needsSetup && (
              <Field label="Full name">
                <Input
                  value={fullName}
                  onChange={(event) => setFullName(event.target.value)}
                  autoComplete="name"
                  placeholder="Louis Baudry"
                />
              </Field>
            )}

            <Field label="Email">
              <Input
                type="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="username"
                placeholder="you@company.com"
              />
            </Field>

            <Field label="Password" hint={needsSetup ? 'At least 10 characters.' : undefined}>
              <Input
                type="password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete={needsSetup ? 'new-password' : 'current-password'}
              />
            </Field>

            {error && (
              <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-800 ring-1 ring-inset ring-red-200">
                {error}
              </p>
            )}

            <Button type="submit" variant="primary" loading={pending} className="w-full">
              {needsSetup ? 'Create account' : 'Sign in'}
            </Button>
          </form>
        </div>

        <p className="mt-4 text-center text-xs text-ink-400">
          Optime Services · prospect follow-up
        </p>
      </div>
    </div>
  );
}
